/*
 * Vlastní sada ikon (24 × 24, tah 1,8). Kreslené záměrně „rukou“ –
 * mírně nepravidelné křivky, aby ladily s tuší a papírem.
 */
export const ICONS = {
  camera:
    'M4.2 8.6c0-1.2.9-2.1 2.1-2.1h1.6l1.3-1.9c.3-.4.7-.6 1.2-.6h3.3c.5 0 .9.2 1.2.6l1.3 1.9h1.6c1.2 0 2.1.9 2.1 2.1v8.1c0 1.2-.9 2.1-2.1 2.1H6.3c-1.2 0-2.1-.9-2.1-2.1z M12 16.1a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.6z',
  photos:
    'M4.5 6.6c0-1.1.9-2 2-2h11c1.1 0 2 .9 2 2v10.8c0 1.1-.9 2-2 2h-11c-1.1 0-2-.9-2-2z M4.8 15.8l4-4.1c.5-.5 1.2-.5 1.7 0l3.2 3.3 M13 14.3l1.6-1.5c.5-.4 1.2-.4 1.6 0l3.1 2.9 M15.2 9.4a1.3 1.3 0 1 0 0-.1',
  pencil:
    'M15.6 4.9c.8-.8 2-.8 2.8 0l.7.7c.8.8.8 2 0 2.8L9.4 18.1l-4.3 1.2 1.1-4.4z M13.8 6.8l3.5 3.4 M6.3 14.9l2.9 2.9',
  bucket:
    'M5.4 10.6l6.4-6.1 6.5 6.4-6.1 6.3c-.8.8-2 .8-2.8 0l-4-3.8c-.8-.8-.8-2 0-2.8z M5 11.2h13 M19.4 15.1s1.6 2 1.6 3.1a1.6 1.6 0 0 1-3.2 0c0-1.1 1.6-3.1 1.6-3.1z M9.4 4.1l2.2 2.2',
  eraser:
    'M13.6 4.9c.8-.8 2-.8 2.8 0l3 3c.8.8.8 2 0 2.8l-7.7 7.8H8.4l-3.1-3.1c-.8-.8-.8-2 0-2.8z M9.8 9.4l5.1 5.1 M8.4 18.5h11.1',
  undo: 'M8.4 5.6L4.6 9.3l3.8 3.7 M4.9 9.3h9.2c3 0 5.4 2.3 5.4 5.1s-2.4 5.1-5.4 5.1h-3.6',
  redo: 'M15.6 5.6l3.8 3.7-3.8 3.7 M19.1 9.3H9.9c-3 0-5.4 2.3-5.4 5.1s2.4 5.1 5.4 5.1h3.6',
  download: 'M12 4.4v10.4 M7.7 10.8l4.3 4.3 4.3-4.3 M5 18.9c4.6.5 9.4.5 14 0',
  share:
    'M12 14.3V4.5 M8.2 8.1L12 4.3l3.8 3.8 M8.3 10.6H7c-1.2 0-2.1.9-2.1 2.1v5.2c0 1.2.9 2.1 2.1 2.1h10c1.2 0 2.1-.9 2.1-2.1v-5.2c0-1.2-.9-2.1-2.1-2.1h-1.3',
  printer:
    'M7.3 9V4.9c0-.4.3-.7.7-.7h8c.4 0 .7.3.7.7V9 M7.2 16.6H5.8c-1 0-1.8-.8-1.8-1.8v-4c0-1 .8-1.8 1.8-1.8h12.4c1 0 1.8.8 1.8 1.8v4c0 1-.8 1.8-1.8 1.8h-1.4 M7.4 13.8h9.2v5.5c0 .3-.2.5-.5.5H7.9c-.3 0-.5-.2-.5-.5z',
  trash:
    'M4.8 7.1h14.4 M9.4 7V5.3c0-.5.4-.9.9-.9h3.4c.5 0 .9.4.9.9V7 M6.6 7.2l.8 11.3c.1.9.8 1.5 1.7 1.5h5.8c.9 0 1.6-.6 1.7-1.5l.8-11.3 M10.2 10.8v5.4 M13.8 10.8v5.4',
  back: 'M14.6 5.3L8 12l6.6 6.7',
  close: 'M6.4 6.3l11.2 11.4 M17.6 6.3L6.4 17.7',
  check: 'M5 12.6l4.3 4.2L19 7.2',
  plus: 'M12 5v14 M5 12h14',
  minus: 'M5 12h14',
  info: 'M12 20.2a8.2 8.2 0 1 0 0-16.4 8.2 8.2 0 0 0 0 16.4z M12 11v5.1 M12 7.9v.1',
  subject:
    'M12 11.2a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.6z M5.8 19.4c.7-3.3 3.2-5.4 6.2-5.4s5.5 2.1 6.2 5.4 M3.6 7.4V5.2c0-.9.7-1.6 1.6-1.6h2.2 M16.6 3.6h2.2c.9 0 1.6.7 1.6 1.6v2.2 M20.4 16.6v2.2c0 .9-.7 1.6-1.6 1.6',
  tap: 'M9.6 12.2V6.4a1.6 1.6 0 0 1 3.2 0v4.8 M12.8 10.4a1.5 1.5 0 0 1 3 0v1.2 M15.8 11a1.5 1.5 0 0 1 3 .2v3.4c0 3-2.4 5.3-5.4 5.3h-.7c-1.8 0-3.4-.9-4.4-2.4l-2.7-4c-.5-.8-.3-1.8.5-2.2.7-.4 1.6-.2 2.1.4l.9 1.2 M6.8 4.7l-1.2-1 M9.6 3.2V2 M4.8 7.4H3.4',
  book: 'M12 6.6c-1.9-1.4-4.5-2-7.6-1.7v12.8c3.1-.3 5.7.3 7.6 1.7 1.9-1.4 4.5-2 7.6-1.7V4.9c-3.1-.3-5.7.3-7.6 1.7z M12 6.6v12.8',
  more: 'M6 12.1v-.2 M12 12.1v-.2 M18 12.1v-.2',
  refresh: 'M19.2 12a7.2 7.2 0 1 1-2.1-5.1 M19.4 4.6v3.8h-3.8',
  palette:
    'M12 20c-4.5 0-8-3.4-8-7.8C4 7.8 7.6 4 12.1 4c4.3 0 7.9 3.1 7.9 7 0 2.4-1.9 3.9-4 3.9h-1.4c-.9 0-1.4 1-1 1.7.5.9 0 3.4-1.6 3.4z M8.2 12.4v-.1 M9.6 8.3v-.1 M13.9 7.6v-.1',
  image: 'M5.2 4.6h13.6c.4 0 .6.3.6.6v13.6c0 .4-.3.6-.6.6H5.2c-.4 0-.6-.3-.6-.6V5.2c0-.4.3-.6.6-.6z M8.8 14.4l2.5-2.6 3.7 3.8 M13.6 14.1l1.4-1.3 2.4 2.4',
  pdf: 'M6.2 3.8h8.1l4.2 4.3V19c0 .7-.5 1.2-1.2 1.2H6.2c-.7 0-1.2-.5-1.2-1.2V5c0-.7.5-1.2 1.2-1.2z M14 4v4.3h4.3 M8.4 13.1h7.2 M8.4 16.4h4.8',
  vector: 'M5.6 18.4C8 10 11.2 6.2 18.4 5.6 M4.2 17h2.8v2.8H4.2z M17 4.2h2.8V7H17z',
  sun: 'M12 16.2a4.2 4.2 0 1 0 0-8.4 4.2 4.2 0 0 0 0 8.4z M12 2.8v1.6 M12 19.6v1.6 M4.2 4.2l1.2 1.2 M18.6 18.6l1.2 1.2 M2.8 12h1.6 M19.6 12h1.6 M4.2 19.8l1.2-1.2 M18.6 5.4l1.2-1.2',
  offline:
    'M3.8 4l16.4 16 M8.4 8.9c-1.5.6-2.8 1.6-3.8 2.8 M12 7.8c2.8 0 5.3 1.1 7.2 3 M8.1 15.1c1-.9 2.4-1.5 3.9-1.5.9 0 1.7.2 2.5.6 M12 18.7v.1',
} as const;

export type IconName = keyof typeof ICONS;
